import { forwardRef, type Ref, type SVGProps } from "react";
const IconExpandOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m19.41 1.54 9.83-.1a1.13 1.13 0 0 1 .79.35 1.08 1.08 0 0 1 .34.78l-.1 9.87a1.07 1.07 0 0 1-1.06 1.06 1 1 0 0 1-1.05-1.05L28.24 5l-8.81 8.84A1 1 0 1 1 18 12.4l8.83-8.82-7.45.08a1 1 0 0 1-1.05-1.05 1.08 1.08 0 0 1 1.08-1.07m-5.75 27.85a1 1 0 0 0-1.05-1.05l-7.45.08L14 19.6a1 1 0 1 0-1.42-1.42L3.76 27l.08-7.47a1 1 0 0 0-1-1.05 1.07 1.07 0 0 0-1.06 1.06l-.1 9.87a1.08 1.08 0 0 0 .34.78 1.13 1.13 0 0 0 .79.35l9.83-.1a1.08 1.08 0 0 0 1.02-1.05"
    />
  </svg>
);
const ForwardRef = forwardRef(IconExpandOutlineSVG);
ForwardRef.displayName = "IconExpandOutline";
export { ForwardRef as IconExpandOutline };
